export const previewFolder = 'temp'
